import { h } from "preact";
function CartItemPrice({ price }) {
    return (h("div", { class: "item__price" },
        h("strong", { "data-field-id": "Cart.products.price" }, price)));
}
export default CartItemPrice;
